// extracted by mini-css-extract-plugin
export default {"link":"tjQnm86bOIPkI01r1sMv","modalWrapper":"sykG3Mi5Y6LCqNIMhXP_"};